module.exports = __webpack_public_path__ + "static/img/evolucao-like-dislike-barra.4fd436d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/evolucao-like-dislike-barra.png
// module id = 2/Ux
// module chunks = 1